{
  "route.tiers.title": "계층 및 혜택",
  "benefits.deleteBenefit.deleteDialog.header": "이 혜택을 삭제하시겠습니까?",
  "benefits.deleteBenefit.deleteDialog.content": "이 혜택을 삭제하면 계층 회원은 더 이상 이 혜택을 받을 수 없습니다.",
  "benefits.deleteBenefit.alertDialog.header": "이 혜택을 삭제할 수 없습니다.",
  "benefits.deleteBenefit.alertDialog.content": "이 혜택은 사용(상환)하지 않은 회원에게 첨부되었습니다. 혜택 번들에서 이 혜택 선택을 취소해 보십시오.",
  "benefits.deleteBenefit.failureAlert": "이 혜택을 삭제하는 동안 오류가 발생했습니다.",
  "benefits.purchaseBenefits.text": "{pointsText} = {currencySymbol}{pointsSpent} 지출",
  "benefits.pointsFromPurchases": "구매에서 {pointsPlaceHolder}",
  "benefits.pointsCatalogBenefitData": "추가 {pointsPlaceHolder}",
  "benefits.createNew.button.tooltip": "혜택을 편집하고 다시 시작하려면 '다음 버전 편집'을 선택해야 합니다.",
  "benefits.createNew.button.label": "혜택 생성",
  "benefits.header.title.regular": "고정 혜택을 계층에 생성하고 지정하십시오. 계층 설정에서 포인트 값과 구매 요구 사항을 정의할 수 있습니다.",
  "benefits.header.title.additional": "Loyalty 회원에게 제공할 추가 혜택을 생성하십시오. Loyalty API에서 추가 혜택을 관리하고 지정할 수 있습니다.",
  "benefits.header.title.fixedBenefits.learnMoreLinkText": "자세히 알아보기",
  "benefits.header.title.fixedBenefits": "고정 혜택을 계층에 생성하고 지정하십시오. 계층 설정에서 포인트 값과 구매 요구 사항을 정의할 수 있습니다. {learnMoreLink}.",
  "benefits.header.title.additionalBenefits.learnMoreLinkText": "자세히 알아보기",
  "benefits.header.title.additionalBenefits": "Loyalty 회원에게 제공할 추가 혜택을 생성하십시오. Loyalty API 또는 구성원 프로파일을 사용하여 추가 혜택을 관리하고 지정할 수 있습니다. {learnMoreLink}.",
  "benefitDefaultData.singleCurrencyText.points": "1{symbol} 지출할 때마다 1포인트 받기",
  "tiers.header.title.learnMoreLinkText": "자세히 알아보기",
  "tiers.header.title": "계층을 생성하고 편집하십시오. 플랜을 시작한 후에는 계층을 추가할 수는 있지만 제거할 수는 없습니다. {learnMoreLink}.",
  "tiers.editIcon.tooltip": "이 계층을 편집하려면 이전 계층 설정을 완료해야 합니다.",
  "tiers.reviewIcon.tooltip": "계층 설정 표시",
  "tiers.status.inactive.tooltip": "이 계층에 대한 설정을 완료해야 합니다.",
  "tiers.cardSubtitle.points.text.invitationOnly": "초대 전용 계층",
  "tiers.cardSubtitle.points.text.pointsUnderMax": "{points} - {maxPoints}{pointsText}(연간 획득)",
  "tiers.cardSubtitle.points.text.pointsAtMax": "{points} + {pointsText}(연간 획득)",
  "tiers.cardSubtitle.purchasesRequired.plural.zero": "",
  "tiers.cardSubtitle.purchasesRequired.plural.one": "{number}개 구매 필요",
  "tiers.cardSubtitle.purchasesRequired.plural.two": "{number}개 구매 필요",
  "tiers.cardSubtitle.purchasesRequired.plural.few": "{number}개 구매 필요",
  "tiers.cardSubtitle.purchasesRequired.plural.many": "{number}개 구매 필요",
  "tiers.cardSubtitle.purchasesRequired.plural.other": "{number}개 구매 필요",
  "tiers.deleteTierDialog.headline": "이 계층을 삭제하시겠습니까?",
  "tiers.deleteTierDialog.content": "이 계층을 삭제하면 계층 회원은 더 낮은 계층으로 떨어지고 현재 계층 혜택을 더 이상 보유할 수 없습니다.",
  "tiers.addNewCard.tooltip.invalid": "이 계층을 생성하려면 이전 계층 설정을 완료해야 합니다.",
  "tiers.addNewCard.text": "계층 생성",
  "tierSetup.deleteCatalogBenefitDialog.headline": "이 혜택을 삭제하시겠습니까?",
  "tierSetup.deleteCatalogBenefitDialog.content": "이 혜택을 삭제하면 계층 회원은 더 이상 이 혜택을 보유할 수 없습니다.",
  "tierSetup.title.new": "계층 생성",
  "tierSetup.title.edit": "계층 설정 -{name}",
  "benefitSetup.title.new": "혜택 생성",
  "benefitSetup.title.edit": "혜택 편집",
  "benefitSetup.type.title": "혜택 유형 선택",
  "benefitSetup.benefitName.title": "혜택 이름",
  "benefitSetup.benefitName.tooltip": "회원에게 표시되는 이 혜택의 이름을 입력하십시오.",
  "benefitSetup.targetMarkets.label": "마켓 선택",
  "benefitSetup.targetMarkets.tooltip": "이 혜택의 대상 마켓을 선택하십시오. 반드시 선택한 마켓에 대한 보상 풀을 설정하십시오.",
  "benefitSetup.notification": "이벤트를 고정 혜택으로 설정하려면 먼저 이벤트 작업을 생성해야 합니다. 선택한 작업으로 이 혜택에 대한 다양한 계층 보상을 정의할 수 있습니다. 이벤트 고정 혜택은 자동화 센터 프로그램에 의해 트리거됩니다.",
  "benefitSetupCustomFields.custom.label": "사용자 정의 보상",
  "benefitSetupCustomFields.custom.tooltip": "회원에게 표시되는 보상 이름입니다. 보상을 사용(상환)하는 방법을 결정할 수 있습니다.",
  "benefitSetupEventFields.eventActionId.label": "작업 선택",
  "benefitSetupEventFields.eventActionId.placeholder": "-- 작업 선택 --",
  "benefitSetupEventFields.tiersAndRewards.title": "계층 및 보상",
  "benefitSetupEventFields.tiersAndRewards.tooltip": "선택한 작업으로 계층 및 보상을 정의할 수 있습니다. 보상은 이 계층의 고정 혜택 테이블에 표시됩니다.",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.label": "액세스 선택",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.placeholder": "-- 액세스 선택 --",
  "benefitSetupExclusiveAccessFields.exclusiveAccessIds.tooltip": "이 혜택에 대한 보상은 액세스 권한으로 사용(상환)됩니다. 각 계층에 대해 활성 액세스 권한을 선택하십시오.",
  "benefitSetupVoucherFields.rewardId.label": "상품권 풀 선택",
  "benefitSetupVoucherFields.rewardId.placeholder": "-- 상품권 풀 선택 --",
  "benefitSetupVoucherFields.rewardId.tooltip": "이 혜택에 대한 보상은 상품권으로 사용(상환)됩니다. 각 계층에 대해 활성 상품권 풀을 선택하십시오.",
  "benefitSetupVoucherFields.tiersAndRewards.title": "계층 및 보상 풀 선택",
  "benefitSetupVoucherFields.tiersAndRewards.tooltip": "이 혜택에 대한 보상은 상품권을 통해 사용(상환)됩니다. 각 계층에 대해 활성 상품권 풀을 선택하십시오.",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.title": "계층 및 액세스 권한 선택",
  "benefitSetupExclusiveAccessFields.tiersAndAccess.tooltip": "이 혜택에 대한 보상은 액세스 권한으로 사용(상환)됩니다. 각 계층에 대해 활성 액세스 권한을 선택하십시오.",
  "tierSetupGeneral.tierValueInPointsTooltip.spend": "이 계층에 들어가는 데 필요한 최소 크레딧 금액을 정의하십시오.",
  "tierSetupGeneral.tierValueInPointsTooltip.points": "이 계층에 들어가는 데 필요한 최소 포인트를 정의하십시오.",
  "tierSetupGeneral.tierValueInPointsTooltip.other": "첫 번째 계층은 진입 계층이며 모든 Loyalty 회원에게 아무런 요구 사항 없이 개방됩니다.",
  "tierSetupGeneral.numberOfPurchasesTooltip.pointsOrSpend": "이 계층에 진입하는 데 필요한 최소 구매를 정의하십시오. 이 요구 사항은 선택 사항이며 포인트 요구 사항에 더하여 제공될 수 있습니다.",
  "tierSetupGeneral.title": "일반 설정",
  "tierSetupGeneral.tierType.label": "계층 유형",
  "tierSetupGeneral.inviteTier.notification": "결제 및 초대를 직접 관리하고 Loyalty API를 호출하거나 구성원 프로파일에서 수동으로 회원을 계층에 추가하십시오. 획득한 포인트는 플랜 설정에 따라 자동으로 계산됩니다. API 또는 구성원 프로파일에서 계층에서 탈퇴한 회원에 대한 작업을 정의할 수도 있습니다.",
  "tierSetupGeneral.tierName.label": "계층 이름",
  "tierSetupGeneral.tierName.tooltip": "회원에게 표시되는 이 계층의 이름을 입력하십시오. 이 이름은 개인 설정 서비스에서 Loyalty 토큰으로도 표시됩니다.",
  "tierSetupGeneral.tierIcon.label": "계층 아이콘",
  "tierSetupGeneral.tierIcon.tooltip": "회원에게 표시되는 아이콘을 선택하십시오. 이 아이콘은 개인 설정 서비스에서 Loyalty 토큰으로도 표시됩니다.",
  "tierSetupGeneral.tierIcon.iconText": "계층에 추가",
  "tierSetupGeneral.requirements.title": "요구 사항",
  "tierSetupGeneral.tierPoints.label.points": "포인트 단위 계층 값",
  "tierSetupGeneral.tierPoints.label.spend": "계층에 필요한 총 크레딧",
  "tierSetupGeneral.tierPoints.postfixLabel.points": "포인트",
  "tierSetupGeneral.tierPoints.postfixLabel.loyalty": "포인트",
  "tierSetupGeneral.tierPoints.postfixLabel.status": "상태 포인트",
  "tierSetupGeneral.tierPoints.postfixLabel.balance": "지출 포인트",
  "tierSetupGeneral.tierPurchases.label": "계층에 필요한 구매 수",
  "tierSetupGeneral.tierPurchases.postfixLabel": "구매",
  "tierSetupGeneral.calculation.tierDropout.label": "계층 계산",
  "tierSetupGeneral.calculation.tierDropout.tooltip": "계층 계산에 이 계층을 포함할지 아니면 계층 계산 및 탈퇴가 없는지 선택하십시오.",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.label": "계층 만료",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.tooltip": "특정 계층을 만료시키고 다른 계층에서 다른 시간에 재계산되도록 하려면 이 설정을 변경하십시오.",
  "tierSetupGeneral.calculation.tiersCalculationYearlyInterval.postfixLabel": "년",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.label": "계층 만료",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.tooltip": "특정 계층을 만료시키고 다른 계층에서 다른 시간에 재계산되도록 하려면 이 설정을 변경하십시오.",
  "tierSetupGeneral.calculation.tiersCalculationMonthlyInterval.postfixLabel": "개월",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.equal": "지출한 1{symbol}당 1개의 크레딧 지급",
  "tierSetupPurchaseBenefits.catalogSelector.label": "브랜드 및 범주 선택",
  "tierSetupPurchaseBenefits.catalogSelector.placeholder": "프로모션할 특정 브랜드나 범주를 선택하십시오.",
  "tierSetupPurchaseBenefits.catalogSelector.disabledItemsTooltip": "이 범주/브랜드는 이전 혜택에서 이미 선택되었습니다.",
  "tierSetupPurchaseBenefits.benefitMessageHeader.title": "혜택 메시지",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltipText": "표시 메시지 형식",
  "tierSetupPurchaseBenefits.benefitMessageTitle.label": "제목",
  "tierSetupPurchaseBenefits.benefitMessageTitle.placeholder": "혜택 메시지 제목을 입력하십시오.",
  "tierSetupPurchaseBenefits.benefitMessageText.label": "텍스트",
  "tierSetupPurchaseBenefits.benefitMessageText.placeholder": "혜택 메시지 텍스트를 입력하십시오.",
  "tierSetupPurchaseBenefits.benefitMessageText.tooltip": "회원에게 표시되는 포인트와 통화 가치는 웹사이트에 선택되어 있는 통화에 따라 다릅니다.",
  "tierSetupPurchaseBenefits.benefitIcon.label": "혜택 아이콘",
  "tierSetupPurchaseBenefits.benefitIcon.selectIconText": "혜택에 추가",
  "tierSetupPurchaseBenefits.tierPurchaseBenefitSpend.options.selectedItems": "선택한 브랜드, 범주 또는 작업에 대해서만 크레딧 지급",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.first": "특정 브랜드 또는 제품 범주를 구매하는 회원에게 다른 포인트 값을 지정하십시오. 포인트는 표준 구매 포인트 대신(추가로 지급되지는 않음) 지급됩니다.",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.points.other": "항목이 자체 포인트 값이 있는 여러 범주에 속하는 경우 회원은 항상 정의된 가장 높은 값으로 보상을 받습니다.",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.first": "특정 브랜드나 범주를 구매하는 회원에게 다른 크레딧 비율을 지정하십시오. 크레딧 비율은 표준 비율 대신 구매에 대한 크레딧 잔액을 업데이트하는 데 사용됩니다.",
  "tierSetupPurchaseBenefits.pointsCatalogBenefitsTooltip.spend.other": "항목이 자체 비율 값이 있는 여러 범주에 속하는 경우 회원은 항상 정의된 가장 높은 값으로 보상을 받습니다.",
  "tierSetupPurchaseBenefits.notification": "포인트는 모든 회원의 Loyalty 플랜 통화입니다. 모든 통화에서 반드시 균일한 포인트 값을 유지하십시오.",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.zero": "최소 {number}포인트가 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.one": "최소 {number}포인트가 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.two": "최소 {number}포인트가 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.few": "최소 {number}포인트가 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.many": "최소 {number}포인트가 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumPoints.plural.other": "최소 {number}포인트가 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.zero": "최소 {number}크레딧이 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.one": "최소 {number}크레딧이 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.two": "최소 {number}크레딧이 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.few": "최소 {number}크레딧이 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.many": "최소 {number}크레딧이 필요합니다.",
  "tierSetupPurchaseBenefits.tierMinimumSpend.plural.other": "최소 {number}크레딧이 필요합니다.",
  "tierSetupPurchaseBenefits.pointsType.title": "계층 포인트 유형",
  "tierSetupPurchaseBenefits.pointsType.label": "포인트 유형",
  "tierSetupPurchaseBenefits.pointsType.tooltip": "계층에 있는 동안 회원에게 지급되는 포인트의 유형을 정의하십시오.",
  "tierSetupPurchaseBenefits.pointsType.error": "포인트 유형이 포인트 곱셈에 대한 작업 정의와 충돌합니다. {actions} 작업을 수정하고 다시 시도하십시오.",
  "tierSetupPurchaseBenefits.pointsType.options.loyalty": "포인트(상태 포인트와 지출 포인트 모두)",
  "tierSetupPurchaseBenefits.pointsType.options.status": "상태 포인트만",
  "tierSetupPurchaseBenefits.pointsType.options.spend": "지출 포인트만",
  "tierSetupPurchaseBenefits.header.points": "구매로 인한 포인트",
  "tierSetupPurchaseBenefits.header.spend": "구매로 인한 Loyalty 크레딧",
  "tierSetupPurchaseBenefits.header.tooltip.spend": "계층 회원이 구매로 획득하는 크레딧 금액을 선택하십시오. 누적된 값은 회원의 Loyalty 지갑에 표시됩니다.",
  "tierSetupPurchaseBenefits.header.tooltip.points": "계층 회원이 구매로 획득하는 포인트의 금액을 선택하십시오. 여러 통화를 관리하는 경우 각각에 대해 값을 설정해야 합니다. 구매에 대해 포인트를 지급하지 않으려는 경우 이 설정은 모든 통화에 대해 동일합니다.",
  "tierSetupPurchaseBenefits.benefitMessageHeader.tooltip": "회원의 Loyalty 지갑에 표시되는 이 혜택에 대한 프로모션 메시지를 입력하십시오.",
  "tierSetupPurchaseBenefits.catalogBenefit.title.points": "브랜드 또는 범주의 포인트.",
  "tierSetupPurchaseBenefits.catalogBenefit.title.spend": "브랜드 또는 범주의 Loyalty 크레딧",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.points": "포인트 값 추가 ",
  "tierSetupPurchaseBenefits.catalogBenefit.addNewBtn.spend": "Loyalty 크레딧 값 추가 ",
  "tierSetupVisibility.title": "표시",
  "tierSetupVisibility.tooltip": "이 계층을 회원에게 숨기고 새로운 항목을 방지할 수 있습니다. 이 계층은 귀하가 다른 계층으로 마이그레이션하기 전까지 계속 기존 회원에게 표시됩니다. 획득한 포인트 계산은 플랜 설정에 따라 자동으로 계속됩니다.",
  "tierSetupVisibility.visible.label": "계층 모드 선택",
  "visibility.options.visible": "표시되는 계층",
  "visibility.options.invisible": "숨겨진 계층",
  "multiLangPurchaseBenefitFields.alert": "모든 언어에 대해 제목과 텍스트를 입력하십시오.",
  "additionalBenefitsUpdateValidator.confirmed.isTrue": "모든 필수 정보를 입력했는지 확인하십시오.",
  "additionalBenefitsUpdateValidator.reason.presence": "내부 추적용 이유를 입력하십시오.",
  "benefitValidator.defaultConstraints.name.presence": "혜택 이름을 입력하십시오.",
  "benefitValidator.defaultConstraints.targetMarkets.presence": "마켓을 입력하십시오.",
  "benefitValidator.eventActionId.presence": "작업을 입력하십시오.",
  "benefitValidator.custom.presence": "보상 설명을 입력하십시오.",
  "benefitValidator.tiers.atLeastOneTier": "계층을 하나 이상 선택하십시오.",
  "benefitValidator.rewardConstraints.rewardId.presence": "보상 풀을 입력하십시오.",
  "benefitValidator.rewardConstraints.tiers.atLeastOneTier": "계층을 하나 이상 선택하십시오.",
  "benefitValidator.rewardConstraints.tiers.tierId.rewardId.benefitSingleReward": "선택을 비우십시오.",
  "benefitValidator.rewardConstraints.exclusiveAccessIds.presence": "액세스 권한을 입력하십시오.",
  "tiersCreationValidator.numberOfTiers.presence": "계층 수를 1~10 범위의 숫자로 입력하십시오.",
  "tiersCreationValidator.numberOfTiers.numericality.notInteger": "계층 수를 1~10 범위의 숫자로 입력하십시오.",
  "tiersCreationValidator.numberOfTiers.numericality.notLessThan": "계층 수를 1~10 범위의 숫자로 입력하십시오.",
  "tiersCreationValidator.numberOfTiers.numericality.notGreaterThan": "배포할 계층을 두 개 이상 입력하십시오.",
  "tiersCreationValidator.spend.presence": "지출 금액을 정수로 입력하십시오.",
  "tiersCreationValidator.spend.numericality.notInteger": "지출 금액을 정수로 입력하십시오.",
  "tiersCreationValidator.spend.numericality.notGreaterThan": "지출 금액을 이전 계층보다 큰 정수로 입력하십시오.",
  "rangeTierPoints.nextTierPoints.plural.zero": "최대 {number}포인트가 필요합니다.",
  "rangeTierPoints.nextTierPoints.plural.one": "최대 {number}포인트가 필요합니다.",
  "rangeTierPoints.nextTierPoints.plural.two": "최대 {number}포인트가 필요합니다.",
  "rangeTierPoints.nextTierPoints.plural.few": "최대 {number}포인트가 필요합니다.",
  "rangeTierPoints.nextTierPoints.plural.many": "최대 {number}포인트가 필요합니다.",
  "rangeTierPoints.nextTierPoints.plural.other": "최대 {number}포인트가 필요합니다.",
  "rangeTierPoints.prevTierPoints.plural.zero": "최소 {number}포인트가 필요합니다.",
  "rangeTierPoints.prevTierPoints.plural.one": "최소 {number}포인트가 필요합니다.",
  "rangeTierPoints.prevTierPoints.plural.two": "최소 {number}포인트가 필요합니다.",
  "rangeTierPoints.prevTierPoints.plural.few": "최소 {number}포인트가 필요합니다.",
  "rangeTierPoints.prevTierPoints.plural.many": "최소 {number}포인트가 필요합니다.",
  "rangeTierPoints.prevTierPoints.plural.other": "최소 {number}포인트가 필요합니다.",
  "tierValidator.name.presence": "계층 이름을 입력하십시오.",
  "tierValidator.name.exclusionIgnoreCase": "이 이름은 이미 존재합니다. 고유한 이름을 입력하십시오.",
  "tierValidator.nameML.multiLangField": "각 언어용 계층 이름을 입력하십시오.",
  "tierValidator.points.presence": "계층 값을 포인트 단위로 입력하십시오.",
  "tierValidator.pointsBenefit.titleML.multiLangField": "각 언어용 제목을 입력하십시오.",
  "tierValidator.pointsBenefit.textML.multiLangField": "각 언어용 텍스트를 입력하십시오.",
  "tierValidator.purchaseBenefits.pointsCatalogBenefits.purchaseBenefitCatalog": "카탈로그 선택을 입력하십시오.",
  "tierValidator.pointsRates.points.presence": "포인트를 입력하십시오.",
  "tierValidator.pointsRates.spent.numericality.notInteger": "지출을 0보다 큰 숫자로 입력하십시오.",
  "tierValidator.pointsRates.spent.numericality.notGreaterThan": "지출을 0보다 큰 숫자로 입력하십시오.",
  "tierValidator.pointsRates.spent.presence": "0보다 큰 숫자를 입력하십시오.",
  "benefitDefaultData.pointsBenefitTitle.points": "구매에서 포인트 획득",
  "benefitDefaultData.pointsBenefitTitle.spend": "구매에서 Loyalty 크레딧 획득",
  "benefitDefaultData.singleCurrencyText.spend": "구매하고 구매에서 크레딧 획득",
  "purchasePointsToken.display": "{ x포인트 }",
  "purchasePointsToken.display.balance": "{ x포인트 지출 가능}",
  "purchasePointsToken.display.status": "{ x 상태 포인트 }",
  "purchaseCurrencyToken.display": "{ x currency }",
  "distribution.contentBox.notification": "기존 고객층이 계층들 간에 어떻게 배포될지 미리 보십시오. 첫 번째 플랜을 시작하기 전에 컨택트 배포를 수정할 수 있습니다.",
  "distribution.contentBox.title": "계층 생성",
  "distribution.contentBox.numberOfTiers.label": "계층 수",
  "distribution.contentBox.calcPeriod.label": "계산 기간",
  "distribution.contentBox.calcPeriod.tooltip": "컨택트 배포를 계산하는 데 사용할 과거 데이터 양을 선택하십시오.",
  "distribution.contentBox.preview.title": "컨택트 배포 미리보기",
  "distribution.contentBox.preview.tooltip": "컨택트는 해당 계층의 모든 요구 사항을 충족하는 경우에만 계층에 배포됩니다.",
  "distribution.contentBox.updateChartButton.label": "차트 업데이트",
  "distribution.contentBox.chart.column.label": "고객 수",
  "distribution.contentBox.chart.series.name": "모든 고객 중 %",
  "distribution.contentBox.singleTierSettings.tooltip.first": "첫 번째 계층은 초보자용 계층이며 모든 Loyalty 고객에게 가입 요건 없이 개방됩니다.",
  "distribution.contentBox.singleTierSettings.tooltip.spend": "고객을 이 계층에 넣기 위해 선택된 기간의 최소 총 지출.",
  "distribution.contentBox.singleTierSettings.tooltip.purchases": "고객을 이 계층에 넣기 위해 선택된 기간의 최소 구매 수.",
  "distribution.contentBox.singleTierSettings.spend.label": "필수 지출",
  "distribution.contentBox.singleTierSettings.purchases.label": "구매 수",
  "tierSetupGeneral.tierPoints.postfixLabel.spend": "{value} 지출",
  "benefitDefaultData.pointsBenefitText.multiCurrency": "{{currencyToken}} 지출마다 {{pointsToken}} 받기"
}
